var visible_overflow_scrollbar = (function( $ ) {

	var _init = function() {
		setInterval( scrollDown, 200 )
	};

	function scrollDown() {
		$( '.visible-overflow-scrollbar' ).each( function() {
			try {
				$( this ).scrollTop( $( this ).scrollTop() + 1 );
				$( this ).scrollTop( $( this ).scrollTop() - 1 );
			} catch ( e ) {
			}
		} );
	}

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = visible_overflow_scrollbar;